import { ApiEndpointClient } from './resource-client';
const VALUATION_API_PREFIX = 'valuation-api/v1';
export class PortfoliosClient extends ApiEndpointClient {
    http;
    constructor(http) {
        super(http, VALUATION_API_PREFIX);
        this.http = http;
    }
    deletePortfolio = async ({ portfolioId }) => {
        return this.delete(`/portfolios/${portfolioId}`, { response: 'content-type-or-empty' });
    };
    getPortfolios = async ({ customerUuid } = {}) => {
        const query = customerUuid ? { customer_uuid: customerUuid } : undefined;
        return this.get('/portfolios/', { query });
    };
    getAllPortfoliosValueOverview = async ({ customerId } = {}) => {
        const query = customerId ? { customer_uuid: customerId } : undefined;
        return this.get('/portfolios/value-overview', { query });
    };
    getAllPortfoliosEnergySummary = async ({ customerId } = {}) => {
        const query = customerId ? { customer_uuid: customerId } : undefined;
        return this.get('/portfolios/energy-summary', { query });
    };
    createPortfolio = async (newPortfolio) => {
        return this.post('/portfolios/', { json: newPortfolio });
    };
    patchPortfolio = async ({ portfolioUuid, operations, }) => {
        await this.patch(`/portfolios/${portfolioUuid}`, { json: operations, response: 'raw' });
    };
    getAllPortfolioValueOverviewExportUrl = async ({ customerId, portfolioId, } = {}) => {
        const query = customerId || portfolioId
            ? {
                ...(customerId ? { customer_uuid: customerId } : {}),
                ...(portfolioId ? { portfolios: portfolioId } : {}),
            }
            : undefined;
        return this.get('/portfolios/value-overview-export', { query });
    };
    getValXmlBulkExportLink = async ({ customerUuid }) => {
        const query = customerUuid ? { customer_uuid: customerUuid } : undefined;
        return this.get('/portfolios/valxml-bulk-export', { query });
    };
}
